import { isTag } from 'anodum';
import findClosestEditableElement from './find-closest-editable-element';
import { LIST_ITEM } from '../constants/editable-elements';

const findRootEditableElement = (el) => {
  const closestEditableElement = findClosestEditableElement(el);
  if (!closestEditableElement) return null;

  if (!isTag(closestEditableElement, LIST_ITEM)) {
    const listItem = closestEditableElement.closest(LIST_ITEM);
    if (listItem && listItem.closest('[contenteditable]')) {
      return listItem;
    }
    return closestEditableElement;
  }
  return closestEditableElement;
};

export default findRootEditableElement;
